import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g>
      <path
        d="M29,9 L3,9 C1.34314575,9 2.02906125e-16,7.65685425 0,6 L0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 L29,0 C30.6568542,1.01453063e-16 32,1.34314575 32,3 L32,6 C32,7.65685425 30.6568542,9 29,9 Z M3,2 C2.44771525,2 2,2.44771525 2,3 L2,6 C2,6.55228475 2.44771525,7 3,7 L29,7 C29.5522847,7 30,6.55228475 30,6 L30,3 C30,2.44771525 29.5522847,2 29,2 L3,2 Z"/>
      <path className="euiIcon__fillSecondary"
            d="M29,32 L3,32 C1.34314575,32 2.02906125e-16,30.6568542 0,29 L0,14 C-2.02906125e-16,12.3431458 1.34314575,11 3,11 L29,11 C30.6568542,11 32,12.3431458 32,14 L32,29 C32,30.6568542 30.6568542,32 29,32 Z M3,13 C2.44771525,13 2,13.4477153 2,14 L2,29 C2,29.5522847 2.44771525,30 3,30 L29,30 C29.5522847,30 30,29.5522847 30,29 L30,14 C30,13.4477153 29.5522847,13 29,13 L3,13 Z"/>
      <polygon points="7.29 17.71 10.59 21 7.29 24.29 8.71 25.71 13.41 21 8.71 16.29"/>
      <rect width="9" height="2" x="15" y="24"/>
    </g>
  </svg>
)
